// Sometimes you just need to make an HTTP call (e.g. to fetch a restricted
// binary, CSV file, or image). Whereas the VeroFreshApiAdapter will
// automatically deserialize responses, update JWT tokens, etc... this adapter
// is much simpler and will just add the auth headers and fire the request, no
// deserialization, etc...

import axios from 'axios'
import { get } from 'lodash'
import UrlHelper from '@/util/Url'
import AuthUtil from '@/util/AuthUtil'
import store from '@/store'

const config = {
  baseURL: UrlHelper.getApiUrl(),
  transformRequest: (data, headers) => {
    if (AuthUtil.hasAuthorizationHeader()) {
      headers.authorization = AuthUtil.getAuthorizationHeader()
    }
    if (store.getters['userModule/hasCustomerContextId']) {
      headers['verofresh-customer-context'] = store.getters['userModule/customerContextId']
    }
    return data
  }
}

const VerofreshHttpAdapter = axios.create(config)

VerofreshHttpAdapter.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // error.response is undefined when the request never got an HTTP response
    // (network drop, aborted request, CORS block). See the note in
    // VeroFreshApiAdapter.responseError. (VF-4310)
    const status = get(error, 'response.status')
    if (status === 401) {
      // Forward to login page, but reload the page to avoid any promise
      // rejections being called due to this error
      window.location.href = '/login'
      // Return a promise that sleeps for 10 seconds, should interrupt further
      // js execution for long enough for the page reload to happen.
      return new Promise(resolve => setTimeout(resolve, 10000))
    } else if (status === 503) {
      store.dispatch('globalMessagingModule/setMaintenanceMode', true)
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export default VerofreshHttpAdapter
